export const siteInformationPath = {
  TERMSCONDITION: '/site-information/terms-of-conditions',
  PRIVACYSTMT: '/site-information/privacy-statement',
  COOKIESPOLICY: '/site-information/cookies-policy',
};
